var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"label":_vm.label,"items":this.countries.map(c => ({ text: c.text, value: c.value })),"outlined":"","hide-details":"","clearable":"","dense":""},on:{"change":_vm.handleChange},model:{value:(_vm.countryIsoCode),callback:function ($$v) {_vm.countryIsoCode=$$v},expression:"countryIsoCode"}})
}
var staticRenderFns = []

export { render, staticRenderFns }